<template>
  <router-view name="category" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Category",
};
</script>
